import { Link, useParams } from 'react-router';

import { useAppContext } from '@app-velocity/config';
import { useI18n } from '@app-velocity/i18n';
import { Button, useModalContext } from '@app-velocity/ui';

import { TeamsRoutesPaths } from '@app-velocity/modules/teams';

export type Props = {
  teamId: string;
};

export const BuyPackButton = ({ teamId }: Props) => {
  const { t } = useI18n();
  const { workspaceId } = useParams<{ workspaceId: string }>();
  const { AVMLink } = useAppContext();
  const { closeModal } = useModalContext();

  const usagePath = `${TeamsRoutesPaths.teamAdmin(teamId, workspaceId!)}/usage`;

  const handleClick = () => {
    closeModal();
  };

  if (AVMLink) {
    return (
      <Button
        fullWidth
        variant="contained"
        color="primary"
        component="a"
        rel="noopener noreferrer"
        href={`${AVMLink}${usagePath}`}
        target="_blank"
      >
        {t('users:no_more_credits.buy_pack')}
      </Button>
    );
  }

  return (
    <Button
      fullWidth
      variant="contained"
      color="primary"
      component={Link}
      onClick={handleClick}
      to={usagePath}
    >
      {t('users:no_more_credits.buy_pack')}
    </Button>
  );
};
